// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3gqhu","productName":"Table_productName__2QbGV"};